import { ActionHandler, ActionHandlerParams } from "..";
import { saveAnswers } from "./saveAnswers";

export const onCompleteSurvey: ActionHandler = async (
  actionParams: ActionHandlerParams
): Promise<void> => {
  await saveAnswers(actionParams);
};
